
const aboutincred2 = {
    "About InCred Financial": [
        {
          question: "What is the business of InCred Financial Services Limited (IFSL)?",
          answer: "InCred Financial Services Limited is a Non-Banking Financial Corporation having segments such as Personal Loan, Student Loan, School Financing & LAP, Anchor & Escrow backed lending & Lending to Financial Institutions."
        },
        {
          question: "Who are the promoters of IFSL?",
          answer: "IFSL was founded by Mr. Bhupinder Singh (Founder & Group CEO) and is backed by marquee investors like KKR Singapore, Teacher’s retirement of Texas, Abu Dhabi Investment Authority, Moore Strategic Ventures and more."
        },
        {
          question: "Is IFSL Rated?",
          answer: "InCred Finance has a long-term rating of A+ by CRISIL & CARE with a stable Outlook."
        },
        {
          question: "What is the AUM of IFSL?",
          answer: "The AUM at the end of Q1FY24 of IFSL is Rs. 6,484 crores with the following split:" + "<br/>" +
          "AUM mix consisted of personal loans (44%, including co-lending portfolio), student loans (18%), lending to FIs (9%), anchor & escrow backed business lines (19%) and secured school financing (8%). Apart from these, erstwhile KKR India’s wholesale portfolio also constituted 2% of the AUM."
          
        },
        {
          question: "What is the profitability of IFSL?",
          answer: "IFSL has been profitable since the first year of operation in 2017.  It reported PBT of Rs.83 crore for the Q1FY2023-24 and Rs.207 crore for the FY 2022-23 on standalone basis."
        },
        {
          question: "What is the extent of Bad loans (NPAs) of IFSL?",
          answer: "The company has a low Gross NPA of 2.4% and Net NPA of 1.1% as on 30th June 2023."
        },
        {
          question: "How leveraged is IFSL? / What is the debt to equity Ratio of IFSL?",
          answer: "IFSL is leveraged 1.6 times as of 31st Mar 2023"
        },
        {
          question: "What is the Capital Adequacy ratio?",
          answer: "As of March 2023, The CRAR is 33.4% as of 31st Mar 2023"
        },
    ],
  }
  
  export default aboutincred2;